import { useState, useEffect } from 'react';
import moment from 'moment';
import NsStandout from '@britishgasenergy/react-nucleus/dist/nuc-components/NsStandout';

import { setBillingConsent, setPreferedStartDate } from 'state/fmrs/fmrs-slice';
import { useFmrs } from 'hooks/useFmrs';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { SupplyStartDate } from './SupplyStartDate';
import { DATE_FORMAT } from 'config/app-config';
import { getQuoteThunk } from 'state/quote/quote-thunks';
import { useQuotePayload } from 'components/direct-sales/quote/hooks/useQuotePayload';
import { pushEvent } from 'state/analytics/analytics-slice';
import { useAppDispatch } from 'hooks/useAppDispatch';

type QuoteBillingConsentProps = {
  shouldShow?: boolean;
};

export const QuoteBillingConsent = ({
  shouldShow = true
}: QuoteBillingConsentProps) => {
  const dispatch = useAppDispatch();
  const getQuotePayload = useQuotePayload();
  const {
    minimumSupplyStartDate,
    preferredStartDate,
    billingConsentMinDate,
    requiresBillingConsent
  } = useFmrs();
  const isMinimumSupplyStartDate =
    !preferredStartDate ||
    moment(minimumSupplyStartDate).isSame(preferredStartDate);
  const formatedMinDate = moment(preferredStartDate, DATE_FORMAT).format(
    'Do MMMM YYYY'
  );
  const [isChooseNewDate, setIsChooseNewDate] = useState(false);

  const handleChooseNewDate = () => {
    setIsChooseNewDate(true);
  };
  const handleConfirm = async ({ preferredStartDate }) => {
    const requiresBillingConsent = !moment(preferredStartDate).isAfter(
      billingConsentMinDate
    );
    setIsChooseNewDate(false);
    dispatch(setPreferedStartDate(preferredStartDate));
    dispatch(setBillingConsent(requiresBillingConsent));
    dispatch(
      pushEvent({
        category: 'calender_nepsales',
        action: 'newdate_selection',
        label: 'confirmed'
      })
    );

    try {
      const payload = getQuotePayload({ preferredStartDate });
      await dispatch(getQuoteThunk(payload));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    dispatch(setPreferedStartDate(preferredStartDate));
    dispatch(setBillingConsent(requiresBillingConsent));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!shouldShow) {
    return null;
  }

  return (
    <NsStandout decoration="cyan">
      {!isChooseNewDate && (
        <>
          <h5>
            {isMinimumSupplyStartDate
              ? 'The soonest you can switch is:'
              : "The supply start date you've chosen is:"}
          </h5>
          <p className="p-large">
            <strong>{formatedMinDate}</strong>
          </p>
          <NsSecondaryCta onClick={handleChooseNewDate}>
            Choose a new date
          </NsSecondaryCta>
          {requiresBillingConsent && (
            <p>
              If you cancel within the 14-day cooling-off period which starts
              tomorrow, we&apos;ll only bill you for the energy you&apos;ve
              used.
            </p>
          )}
        </>
      )}
      {isChooseNewDate && <SupplyStartDate onHandleConfirm={handleConfirm} />}
    </NsStandout>
  );
};
